import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError } from 'rxjs/operators';

import * as fromStore from '../store';
import { of } from 'rxjs';

export const TipInsightsGuard: CanActivateFn = route => {
  const store = inject(Store);
  return store
    .select(fromStore.getInsightsTipsLoaded)
    .pipe(
      tap(loadedInsights => {
        if (!loadedInsights) {
          store.dispatch(fromStore.LoadInsightsTips());
        }
      }),
      filter(loadedInsights => !!loadedInsights),
      take(1)
    )
    .pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
};
